import { SVGProps } from '@components/Icon/types';

export const CheckCircleInverted = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.966675 10C0.966675 5.03008 5.03008 0.966675 10 0.966675C14.9699 0.966675 19.0333 5.03008 19.0333 10C19.0333 14.9699 14.9699 19.0333 10 19.0333C5.03008 19.0333 0.966675 14.9699 0.966675 10ZM10 2.36667C5.80327 2.36667 2.36667 5.80327 2.36667 10C2.36667 14.1967 5.80327 17.6333 10 17.6333C14.1967 17.6333 17.6333 14.1967 17.6333 10C17.6333 5.80327 14.1967 2.36667 10 2.36667Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.36667 10C2.36667 5.80327 5.80327 2.36667 10 2.36667C14.1967 2.36667 17.6333 5.80327 17.6333 10C17.6333 14.1967 14.1967 17.6333 10 17.6333C5.80327 17.6333 2.36667 14.1967 2.36667 10ZM14.037 7.14705C14.3102 7.42066 14.3098 7.86388 14.0362 8.137L9.31117 12.8537C9.03773 13.1266 8.59486 13.1264 8.32166 12.8532L5.96333 10.4949C5.68996 10.2215 5.68996 9.77831 5.96333 9.50495C6.23669 9.23158 6.67991 9.23158 6.95328 9.50495L8.81707 11.3687L13.0471 7.14618C13.3207 6.87305 13.7639 6.87344 14.037 7.14705Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'check-circle-inverted';
